import { Box, Button, Card, CardContent, Dialog, DialogContent, Grid, Tooltip } from '@mui/material'
import { getColorDueDate, PASTEL_COLOR } from 'common/utils/ColorUtil'
import { NEW, OTHER } from 'common/components/action/ActionConstant'
import useCustomerFavorites from './useCustomerFavorites'
import useLocalStorage from 'common/hooks/useLocalStorage'
import { ALIGN, CardTable, SORT } from 'common/components/datatable/Table'
import Checkbox from 'common/components/form/Checkbox'
import Input from 'common/components/form/Input'
import Select from 'common/components/form/Select'
import { CardTitle } from 'common/components/card/Card'
import { darkBlue } from 'app/theme'
import ConfirmModal from 'common/components/modal/ConfirmModal'
import { BasicDialogAction, BasicDialogTitle } from 'common/components/modal/DialogComponents'
import PropTypes from 'prop-types'
import React, { useEffect, useMemo, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import useActions from 'common/hooks/useActions'
import useBoolean from 'common/hooks/useBoolean'
import useTitles from 'common/hooks/useTitles'
import { getDate, getYear } from 'common/utils/DateUtil'
import { hasPermission } from 'common/utils/HabilitationUtil'
import CustomerInstanceDialog from '../customer/components/CustomerInstanceDialog'
import { compact, isNil, orderBy, uniq } from 'lodash'
import { useNavigate } from 'react-router'
import { createCustomer, fetchCustomers, reset, selectCustomers, updateCustomer } from 'gdl/customers/CustomersSlice'
import { createNote } from 'gdl/notes/NotesSlice'
import { fetchInstances } from 'supervision/instances/InstancesSlice'
import { ALERT_GREEN, ALERT_RED, ALERT_YELLOW, COMMERCIAL_SENSITIVITY, CUSTOMER_STATUS, STATE, VIGILANCE } from 'dashboard/utils/DashboardUtils'
import { Circle } from '@mui/icons-material'
import useFetch from 'common/hooks/useFetch'
import ApplicationConf from 'conf/ApplicationConf'
import moment from 'moment'
import CustomerCard from 'gdl/customer/CustomerCard'
import NoteCard from 'gdl/notes/NoteCard'
import LastNoteDialog from './LastNoteDialog'
import CustomersCharts from './CustomersCharts'
import useNoteTypeOptions from 'gdl/notes/useNoteTypeOptions'

const PopinCustomer = ({
    isOpen = false,
    close = () => {},
}) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const {
        instances,
    } = useSelector(store => ({
        instances: store.supervision.instances,
    }), shallowEqual)

    const {
        value: isLoading,
        setTrue: loading,
        setFalse: notLoading,
    } = useBoolean(false)

    const {
        value: isChainCreate,
        toggle: toggleChainCreate,
    } = useBoolean(false)

    const {
        value: isPopinOpen,
        setTrue: onOpenPopin,
        setFalse: onClosePopin,
    } = useBoolean(false)
    const {
        value: isConfirmOpen,
        setTrue: onOpenConfirm,
        setFalse: onCloseConfirm,
    } = useBoolean(false)

    const [selectedInstance, setSelectedInstance] = useState()

    const [customer, setCustomer] = useState()
    const [customerInstances, setCustomerInstances] = useState([])
    const [customerContributors, setCustomerContributors] = useState([])

    const formattedCustomerInstances = customerInstances.map(ci => ({
        instance: ci.instance,
        name: instances.byId[ci.instance]?.name ?? 'Inconnue',
        type: ci.instanceType,
    }))

    useEffect(() => {
        if (isOpen) {
            setCustomer()
            setCustomerInstances([])
            setCustomerContributors([])
        }
    }, [isOpen])

    const resetAllField = () => {
        setCustomer()
        setCustomerInstances([])
        setCustomerContributors([])
    }

    const validate = () => {
        loading()
        dispatch(createCustomer({
            id: -1,
            ...customer,
            creationDate: 0,
            updateDate: 0,
            updateLogin: '',
            contributors: customerContributors,
            instances: customerInstances,
            notes: [],
        }))
            .then(res => {
                if (!res) return
                dispatch(fetchCustomers())
                if (!isChainCreate) {
                    navigate(`/customer/${res.payload.id}`)
                    close()
                } else {
                    resetAllField()
                }
            })
            .finally(notLoading)
    }

    const onDeleteInstance = row => {
        setSelectedInstance(row.instance)
        onOpenConfirm()
    }

    const onEditInstance = row => {
        setSelectedInstance(row.instance)
        onOpenPopin()
    }

    const customerInstance = customerInstances.find(p => p.instance === selectedInstance)


    return (
        <Dialog
            open={isOpen}
            maxWidth={'xl'}
        >
            <BasicDialogTitle onClose={close}>
                Client
            </BasicDialogTitle>
            <DialogContent style={{ overflowX: 'hidden' }}>
                <Grid container spacing={1}>
                    <Grid size={12}>
                        <CustomerCard customer={customer} onChange={setCustomer} />
                    </Grid>
                    <Grid size={6}>
                        <CardTable
                            title='Instances'

                            rows={formattedCustomerInstances}
                            headers={[{ key: 'name', value: 'Instance' }, { key: 'type', value: 'Type d\'instance' }]}

                            actions={[{
                                icon: 'add',
                                onClick: onOpenPopin,
                                tooltip: 'Lier à une instance',
                            }]}
                            lineActions={[
                                { icon: 'delete', onClick: onDeleteInstance },
                                { icon: 'edit', onClick: onEditInstance },
                            ]}
                        />
                        <CustomerInstanceDialog
                            isOpen={isPopinOpen}
                            customerInstance={customerInstance}
                            onClose={() => {
                                setSelectedInstance()
                                onClosePopin()
                            }}
                            onValidate={newInst => {
                                const formattedParam = { ...newInst, customer: -1 }
                                setCustomerInstances(insts => {
                                    if (isNil(selectedInstance)) return [...insts, formattedParam]
                                    return insts.map(p => p.instance === selectedInstance ? formattedParam : p)
                                })
                                setSelectedInstance()
                                onClosePopin()
                            }}
                        />
                        <ConfirmModal
                            isOpen={isConfirmOpen}
                            title='Êtes-vous sûr de vouloir supprimer cette liaison ?'
                            onValidate={() => {
                                setCustomerInstances(insts => insts.filter(i => i.instance !== selectedInstance))
                                onCloseConfirm()
                            }}
                            onClose={onCloseConfirm}
                        />
                    </Grid>
                    <Grid size={6}>
                        <CardTable
                            title='Intervenant'

                            rows={customerContributors}
                            headers={[{ key: 'name', value: 'Nom' }, { key: 'type', value: 'Type d\'intervenant' }]}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <BasicDialogAction
                buttonLabel={'Créer'}
                onValidate={validate}
                isDisabled={!customer?.name || !customer?.startDate}
                isLoading={isLoading}
            >
                <Checkbox
                    label='Saisir un autre client'
                    checked={isChainCreate}
                    onToggle={toggleChainCreate}
                    labelStyle={{ color: '#555', fontWeight: 'normal' }}
                />
            </BasicDialogAction>
        </Dialog>
    )
}

PopinCustomer.propTypes = {
    isOpen: PropTypes.bool,
    close: PropTypes.func,
}

const HEADERS = [
    { key: 'name', value: 'Nom' },
    // { key: 'description', value: 'Description' },
    { key: 'chefProjet', value: 'Chef de projet' },
    { key: 'interlocuteur', value: 'Interlocuteur\nprincipal' },
    { key: 'status', value: 'Statut' },
    { key: 'startDate', value: 'Début' },
    { key: 'endDate', value: 'Fin' },
    { key: 'nextDeadline', value: 'Prochaine\néchéance' },
    { key: 'lastCopil', value: 'Dernier\nCOPIL' },
    { key: 'vigilance', value: 'Vigilance' },
    { key: 'sensitivity', value: 'Sensibilité' },
    { key: 'etat', value: 'État', width: 90 },
]

// Pastille de couleur (rond) affichée devant l'option dans les Selects de filtre.
const pastille = (color) => <Circle sx={{ color, fontSize: '1rem', marginRight: '5px', verticalAlign: 'middle' }} />

// `color` = couleur du rond, reprise des colonnes Statut/Vigilance ; `icon` = la pastille pour les Selects.
const STATUS_OPTIONS = [
    { value: 1, label: 'Démarrage', color: '#00b0f0', icon: pastille('#00b0f0') },
    { value: 2, label: 'En cours', color: '#92d050', icon: pastille('#92d050') },
    { value: 3, label: 'Archivé', color: '#bfbfbf', icon: pastille('#bfbfbf') },
]

const VIGILANCE_OPTIONS = [
    { value: VIGILANCE.MEDIUM, label: 'Moyenne', color: 'orange', icon: pastille('orange') },
    { value: VIGILANCE.HIGH, label: 'Elevée', color: 'red', icon: pastille('red') },
]

// Options du menu contextuel de vigilance (avec « Aucune » pour la retirer — null = None côté back).
const VIGILANCE_MENU = [{ value: null, label: 'Aucune' }, ...VIGILANCE_OPTIONS]

// Libellé + pastille de la sensibilité commerciale pour la colonne du tableau (même rendu que la vigilance).
const getSensitivity = (value) => {
    const option = COMMERCIAL_SENSITIVITY.find(o => o.value === value)
    return isNil(option) ? '' : <Grid container spacing={1} alignItems='center'><Circle sx={{ color: option.color }} />{option.label}</Grid>
}

const STATUS_ARCHIVE = 3

// Couleur d'une instance : même règle que l'accueil (KwakeUpMap, vue Back-end) pour rester cohérent.
// Basée sur le statut back-end : KO -> rouge, OK -> vert, sinon jaune.
const globalInstanceColor = (inst) => {
    switch (inst.statusBackend) {
        case STATE.KO: return ALERT_RED
        case STATE.OK: return ALERT_GREEN
        default: return ALERT_YELLOW
    }
}

// Rang de gravité pour le tri de la colonne État (rouge > orange > vert).
const stateRank = (color) => (color === ALERT_RED ? 2 : color === ALERT_YELLOW ? 1 : 0)

// Chef de projet interne (Aquasys) : contributeur CHIEF avec un login (pas un intervenant externe).
const internalChief = (customer) => customer.contributors?.find(c => c.typeContributor === 'CHIEF' && c.login)

// Coordonnées d'un contributeur affichées au survol (nom + email + téléphone renseignés).
const contactTooltip = (c) => (
    <span style={{ whiteSpace: 'pre-line' }}>
        {[c.name, c.email && `Email : ${c.email}`, c.telephone && `Tél : ${c.telephone}`].filter(Boolean).join('\n')}
    </span>
)

// Ancienneté d'une date (dernier COPIL / dernière note) : rouge au-delà de 6 mois, orange au-delà de 3 mois.
const STALE_THRESHOLDS = [
    { months: 6, color: PASTEL_COLOR.red },
    { months: 3, color: PASTEL_COLOR.orange },
]

// Seuil d'ancienneté dépassé par une date (undefined si récente ou client archivé : pas d'alerte).
const getStaleThreshold = (date, isArchived) => {
    const ageMonths = moment().diff(moment(date), 'months', true)
    return isArchived ? undefined : STALE_THRESHOLDS.find(t => ageMonths > t.months)
}

// Date dans une pastille colorée si elle est trop ancienne, comme les échéances des lots clients.
const StaleDate = ({ date, label, isArchived = false }) => {
    const threshold = getStaleThreshold(date, isArchived)
    if (!threshold) {
        return getDate(date)
    }
    return (
        <Tooltip title={`${label} il y a plus de ${threshold.months} mois`}>
            <Box component='span' sx={{ backgroundColor: threshold.color, color: 'white', fontWeight: 700, borderRadius: '10px', px: 0.75, py: '1px' }}>
                {getDate(date)}
            </Box>
        </Tooltip>
    )
}
StaleDate.propTypes = { date: PropTypes.number, label: PropTypes.string, isArchived: PropTypes.bool }

// Prochaine échéance, mêmes règles que l'échéance des lots clients : pastille rouge (texte blanc) si dépassée, texte
// orange à moins de 7 jours (pas d'alerte pour les clients archivés).
const NextDeadline = ({ date, isArchived = false }) => {
    const color = isArchived ? null : getColorDueDate(date, null)
    const isOverdue = color === PASTEL_COLOR.red
    return (
        <Box
            component='span'
            sx={{
                fontWeight: color ? 700 : undefined,
                color: isOverdue ? 'white' : color,
                ...(isOverdue ? { backgroundColor: color, borderRadius: '10px', px: 0.75, py: '1px' } : {}),
            }}
        >
            {getDate(date)}
        </Box>
    )
}
NextDeadline.propTypes = { date: PropTypes.number, isArchived: PropTypes.bool }

// Type (en gras) et contenu de la dernière note affichés au survol du (i), précédés de l'alerte d'ancienneté.
const noteTooltip = (note, stale) => (
    <span style={{ whiteSpace: 'pre-line' }}>
        {stale && <b style={{ color: stale.color }}>{`Dernière note il y a plus de ${stale.months} mois\n`}</b>}
        <b>{`${getDate(note.creationDate)} : ${note.typeNote}`}</b>{note.comment ? `\n${note.comment}` : ''}
    </span>
)

// Filtre par défaut : clients en Démarrage (1) et En cours (2) — les archivés (3) sont masqués.
const DEFAULT_FILTERS = { status: [1, 2] }

const FilterCustomers = ({ filters = {}, setFilters = () => {}, chiefOptions = [] }) => {
    const { search = '', status = [], vigilance = [], chief = [] } = filters
    return (
        <Card sx={{ marginBottom: 1 }}>
            <CardTitle title='Filtre' color={darkBlue} />
            <CardContent>
                <Grid container spacing={1} alignItems='center'>
                    <Grid size={2}>
                        <Input
                            label='Rechercher'
                            value={search}
                            onChange={v => setFilters({ ...filters, search: v })}
                        />
                    </Grid>
                    <Grid size={2}>
                        <Select
                            multiple
                            label='Statut'
                            value={status}
                            items={STATUS_OPTIONS}
                            onChange={v => setFilters({ ...filters, status: v })}
                            undefinedValue
                        />
                    </Grid>
                    <Grid size={2}>
                        <Select
                            multiple
                            label='Vigilance'
                            value={vigilance}
                            items={VIGILANCE_OPTIONS}
                            onChange={v => setFilters({ ...filters, vigilance: v })}
                            undefinedValue
                        />
                    </Grid>
                    <Grid size={2}>
                        <Select
                            multiple
                            label='Chef de projet'
                            value={chief}
                            items={chiefOptions}
                            onChange={v => setFilters({ ...filters, chief: v })}
                            undefinedValue
                        />
                    </Grid>
                    <Grid container size='grow' justifyContent='flex-end' alignItems='center'>
                        <Button variant='outlined' onClick={() => setFilters(DEFAULT_FILTERS)}>Réinitialiser</Button>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

FilterCustomers.propTypes = {
    filters: PropTypes.object,
    setFilters: PropTypes.func,
    chiefOptions: PropTypes.arrayOf(PropTypes.shape({})),
}

const CustomersListApp = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const {
        user,
        instancesById,
    } = useSelector(store => ({
        user: store.app.user,
        instancesById: store.supervision.instances.byId,
    }), shallowEqual)
    const listCustomers = useSelector(selectCustomers, shallowEqual)

    // État des instances : données enrichies du dashboard supervision, indexées par id d'instance.
    const { data: dashboard = {} } = useFetch(ApplicationConf.dashboard())
    const instanceStateById = useMemo(() => {
        const map = {}
        ;(dashboard.instances ?? []).forEach(i => {
            map[i.instanceId] = i
        })
        return map
    }, [dashboard])

    const {
        value: isOpenPopin,
        setTrue: openPopin,
        setFalse: closePopin,
    } = useBoolean(false)

    const [filters, setFilters] = useState(DEFAULT_FILTERS)
    const [noteCustomer, setNoteCustomer] = useState(undefined)
    const [noteToAdd, setNoteToAdd] = useState(undefined)

    // Favoris de l'utilisateur (hook partagé avec la fiche client).
    const { favorites, isFavorite, toggleFavorite } = useCustomerFavorites()
    const [showFavoritesOnly, setShowFavoritesOnly] = useState(false)

    useTitles(() => [{
        label: 'Clients',
        href: '/customer',
    }], [])

    useEffect(() => {
        dispatch(fetchInstances())
        dispatch(fetchCustomers())
    }, [dispatch])

    const getVigilance = (vigilance) => {
        if (vigilance === VIGILANCE.MEDIUM) return <Grid container spacing={1} alignItems='center'><Circle sx={{ color: 'orange' }} />Moyenne</Grid>
        if (vigilance === VIGILANCE.HIGH) return <Grid container spacing={1} alignItems='center'><Circle sx={{ color: 'red' }} />Elevée</Grid>
        return ''
    }

    // Types de note déjà utilisés (tous clients) pour l'autocomplete ; un type inédit reste saisissable.
    const noteTypeOptions = useNoteTypeOptions()

    // Options du filtre Chef de projet : chefs de projet internes distincts.
    const chiefOptions = useMemo(
        () => uniq(compact(listCustomers.map(c => internalChief(c)?.name))).sort().map(n => ({ value: n, label: n })),
        [listCustomers],
    )

    const filteredCustomers = useMemo(() => {
        const { search, status, vigilance, chief } = filters
        const bySearch = search
            ? listCustomers.filter(c => `${c.name ?? ''} ${c.mnemonic ?? ''} ${c.description ?? ''}`.toLocaleLowerCase().includes(search.toLocaleLowerCase()))
            : listCustomers
        const byStatus = status?.length ? bySearch.filter(c => status.includes(c.status)) : bySearch
        const byVigilance = vigilance?.length ? byStatus.filter(c => vigilance.includes(c.vigilance)) : byStatus
        const byChief = chief?.length ? byVigilance.filter(c => chief.includes(internalChief(c)?.name)) : byVigilance
        return showFavoritesOnly ? byChief.filter(c => (favorites ?? []).includes(c.id)) : byChief
    }, [listCustomers, filters, showFavoritesOnly, favorites])

    // Mémorise l'ordre des ids affichés (tri par défaut = nom/mnémonique) pour la navigation
    // précédent/suivant depuis la fiche client.
    const [, setNavIds] = useLocalStorage('customers:navIds', [])
    useEffect(() => {
        setNavIds(orderBy(filteredCustomers, c => (c.mnemonic || c.name || '').toLocaleLowerCase()).map(c => c.id))
    }, [filteredCustomers, setNavIds])

    const formattedCustomers = useMemo(() => filteredCustomers
        .map(customer => {
            // La note la plus récente : le (i) n'apparaît que si le client a au moins une note.
            const lastNote = orderBy(customer.notes ?? [], ['creationDate'], ['desc'])[0]
            // Dernier COPIL : note de type COPIL la plus récente.
            const lastCopil = orderBy((customer.notes ?? []).filter(n => n.typeNote?.trim().toUpperCase() === 'COPIL'), ['creationDate'], ['desc'])[0]
            // Le mnémonique prime sur le nom dans le tableau quand il est renseigné.
            const label = customer.mnemonic || customer.name
            const chief = internalChief(customer)
            const principal = customer.contributors?.find(c => c.typeContributor === 'PRINCIPAL')
            // Une pastille par instance du client, couleur = état global de l'instance (dashboard).
            const instanceStates = (customer.instances ?? [])
                .map(ci => instanceStateById[ci.instance])
                .filter(Boolean)
                .map(inst => ({
                    id: inst.instanceId,
                    name: instancesById?.[inst.instanceId]?.name ?? inst.name,
                    color: globalInstanceColor(inst),
                }))
            const worstRank = instanceStates.reduce((max, s) => Math.max(max, stateRank(s.color)), -1)
            return {
                id: customer.id,
                // Léger fond gris pour les clients archivés.
                colorLine: customer.status === STATUS_ARCHIVE ? '#f0f0f0' : undefined,
                name: { value: label, tooltip: customer.mnemonic ? customer.name : undefined },
                etat: {
                    value: instanceStates.length ? (
                        <Grid container spacing={0.5} alignItems='center'>
                            {instanceStates.map(s => (
                                <Tooltip key={s.id} title={s.name}>
                                    <Circle sx={{ color: s.color, fontSize: '1rem' }} />
                                </Tooltip>
                            ))}
                        </Grid>
                    ) : '',
                    sortValue: worstRank,
                },
                description: customer.description?.length > 40 ? `${customer.description.substring(0, 40)}...` : customer.description,
                chefProjet: { value: chief?.name ?? '' },
                interlocuteur: principal ? { value: principal.name, tooltip: contactTooltip(principal) } : { value: '' },
                startDate: { value: customer.startDate ? getYear(customer.startDate) : '', sortValue: customer.startDate ?? -1 },
                endDate: { value: customer.endDate ? getYear(customer.endDate) : '', sortValue: customer.endDate ?? -1 },
                nextDeadline: {
                    value: customer.nextDeadline ? <NextDeadline date={customer.nextDeadline} isArchived={customer.status === STATUS_ARCHIVE} /> : '',
                    sortValue: customer.nextDeadline ?? -1,
                },
                lastCopil: {
                    value: lastCopil ? <StaleDate date={lastCopil.creationDate} label='Dernier COPIL' isArchived={customer.status === STATUS_ARCHIVE} /> : '',
                    sortValue: lastCopil?.creationDate ?? -1,
                },
                status: { value: CUSTOMER_STATUS.find(s => s.value === customer.status)?.label, sortValue: customer.status },
                vigilance: { value: getVigilance(customer.vigilance), sortValue: customer.vigilance },
                sensitivity: { value: getSensitivity(customer.commercialSensitivity), sortValue: customer.commercialSensitivity ?? -1 },
                // Champs hors colonnes, exploités par les lineActions.
                lastNote,
                lastNoteStale: lastNote ? getStaleThreshold(lastNote.creationDate, customer.status === STATUS_ARCHIVE) : undefined,
            }
        })
    , [filteredCustomers, instanceStateById, instancesById])

    useActions(() => [{
        type: NEW,
        onClick: openPopin,
        displayed: hasPermission(user, 'customers', 'create'),
    }, {
        type: OTHER,
        icon: showFavoritesOnly ? 'star' : 'star_border',
        tooltip: showFavoritesOnly ? 'Afficher tous les clients' : 'Afficher uniquement les favoris',
        onClick: () => setShowFavoritesOnly(v => !v),
    }], [showFavoritesOnly])

    const applyCustomerChange = (customer, patch) => {
        if (isNil(customer)) {
            return
        }
        dispatch(updateCustomer({ ...customer, ...patch })).then(() => {
            dispatch(reset())
            dispatch(fetchCustomers())
        })
    }

    // Menu clic droit : changer le statut ou la vigilance (l'option courante est masquée).
    const customerContextActions = (row) => {
        const customer = listCustomers.find(c => c.id === row.id)
        const currentVigilance = customer?.vigilance ?? null
        return [
            ...STATUS_OPTIONS.map(s => ({
                label: `Statut : ${s.label}`,
                icon: <Circle sx={{ color: s.color, fontSize: '1rem' }} />,
                displayed: customer?.status !== s.value,
                onClick: () => applyCustomerChange(customer, { status: s.value }),
            })),
            ...VIGILANCE_MENU.map(v => ({
                label: `Vigilance : ${v.label}`,
                icon: v.color ? <Circle sx={{ color: v.color, fontSize: '1rem' }} /> : undefined,
                displayed: currentVigilance !== v.value,
                onClick: () => applyCustomerChange(customer, { vigilance: v.value }),
            })),
            {
                label: isFavorite(row.id) ? 'Retirer des favoris' : 'Ajouter aux favoris',
                icon: isFavorite(row.id) ? 'star_border' : 'star',
                color: '#f5b301',
                onClick: () => toggleFavorite(row.id),
            },
        ]
    }

    return (
        <>
            <FilterCustomers filters={filters} setFilters={setFilters} chiefOptions={chiefOptions} />
            <CustomersCharts customers={filteredCustomers} />
            <CardTable
                title={'Clients'}
                color={'#161832'}
                rows={formattedCustomers}
                headers={HEADERS}
                rememberState
                rememberAll
                onClickRow={({ id }) => navigate(`/customer/${id}`)}
                contextActions={customerContextActions}
                lineActions={[{
                    icon: 'star',
                    color: '#f5b301',
                    align: ALIGN.LEFT,
                    // Étoile visible uniquement pour les favoris ; sinon cellule vide (pas de décalage).
                    displayed: (row) => isFavorite(row.id),
                    tooltip: 'Retirer des favoris',
                    onClick: (row) => toggleFavorite(row.id),
                }, {
                    // Dernière note ancienne : (i) plein (plus visible) en rouge au-delà de 6 mois, orange au-delà de 3 mois.
                    icon: (row) => (row.lastNoteStale ? 'info' : 'info_outlined'),
                    align: ALIGN.RIGHT,
                    color: (row) => row.lastNoteStale?.color,
                    tooltip: (row) => (isNil(row.lastNote) ? undefined : noteTooltip(row.lastNote, row.lastNoteStale)),
                    displayed: (row) => !isNil(row.lastNote),
                    onClick: (row) => setNoteCustomer({ name: row.name?.value, note: row.lastNote }),
                    positionTooltip: 'left',
                }, {
                    icon: 'note_add',
                    align: ALIGN.RIGHT,
                    tooltip: 'Ajouter une note',
                    onClick: (row) => setNoteToAdd({ idClient: row.id, customerName: row.name?.value, creationDate: moment().valueOf(), creationLogin: user?.login }),
                }]}
                defaultSort={ { column: 'name', direction: SORT.ASC } }
            />
            <PopinCustomer
                isOpen={isOpenPopin}
                close={closePopin}
            />
            <LastNoteDialog
                open={!isNil(noteCustomer)}
                onClose={() => setNoteCustomer(undefined)}
                note={noteCustomer?.note}
                customerName={noteCustomer?.name}
            />
            {!isNil(noteToAdd) && (
                <Dialog open maxWidth='md'>
                    <BasicDialogTitle onClose={() => setNoteToAdd(undefined)}>
                        {`Nouvelle note — ${noteToAdd.customerName ?? ''}`}
                    </BasicDialogTitle>
                    <DialogContent>
                        <NoteCard note={noteToAdd} onChange={setNoteToAdd} typeOptions={noteTypeOptions} />
                    </DialogContent>
                    <BasicDialogAction
                        buttonLabel='Valider'
                        onValidate={() => dispatch(createNote(noteToAdd)).then(() => {
                            setNoteToAdd(undefined)
                            dispatch(reset())
                            dispatch(fetchCustomers())
                        })}
                        isDisabled={!noteToAdd?.typeNote || !noteToAdd?.comment || !noteToAdd?.creationDate}
                    />
                </Dialog>
            )}
        </>
    )
}

export default CustomersListApp